const brandIdLocalStorageIdentifier = 'selected_brand_id';
const isClientView: boolean = window.self !== window.top;
const storage = isClientView ? sessionStorage : localStorage;

export const getStorageBrandId = () => {
  const stringSelectedBrandId = storage.getItem(brandIdLocalStorageIdentifier);
  const selectedBrandId = stringSelectedBrandId ? Number(stringSelectedBrandId) : undefined;

  return {
    brandId: selectedBrandId,
  };
};

export const updateStorageBrandId = (brandId?: number) => {
  const { brandId: selectedBrandId } = getStorageBrandId();

  if (!brandId) {
    clearStorageBrandId();
  }
  if (selectedBrandId === brandId) return;
  storage.setItem(brandIdLocalStorageIdentifier, String(brandId));
};

export const clearStorageBrandId = () => {
  storage.removeItem(brandIdLocalStorageIdentifier);
};
